const VIEW_TRANSITION_SKIP_PATTERNS = [
  'Transition was skipped',
  'New ViewTransition started',
];

/**
 * Chromium aborts an in-flight View Transition when navigation starts again.
 * The browser rejects the old transition with AbortError; that is expected and
 * not an application failure.
 */
export function isViewTransitionSkipError(message: string): boolean {
  return VIEW_TRANSITION_SKIP_PATTERNS.every((pattern) =>
    message.includes(pattern),
  );
}
